import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { trackDailyContentIdeaClick } from './userJourneyTracker';
import './HomeDashboardCards.css';
import './DailyContentIdeaBar.css';

const GRADIENT_ID = 'home-dash-ig-grad';

function LightbulbIcon() {
  return (
    <svg className="home-dash-btn-outline-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26A7 7 0 0 0 12 2z"
        stroke={`url(#${GRADIENT_ID})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function DailyContentIdeaBar({ onRequireAuth }) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <div className="daily-content-idea-bar-wrap">
      <svg width="0" height="0" className="home-dash-btn-outline-defs" aria-hidden="true">
        <defs>
          <linearGradient id={GRADIENT_ID} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#5170ff" />
            <stop offset="100%" stopColor="#ff66c4" />
          </linearGradient>
        </defs>
      </svg>
      <button
        type="button"
        className="home-dash-btn home-dash-btn-outline"
        aria-label="Daily content idea"
        onClick={() => {
          trackDailyContentIdeaClick();
          if (!isAuthenticated) {
            onRequireAuth?.();
            return;
          }
          navigate('/dailycontent');
        }}
      >
        <LightbulbIcon />
        <span className="home-dash-btn-outline-text">Daily content idea</span>
      </button>
    </div>
  );
}
